import '../../../styles/scss/banner/banner.scss'
import {GEButton} from '../../../common/buttons'
import IconTelegram from '../../elements/svg_icons/IconTelegram'
import IconYoutube from '../../elements/svg_icons/IconYoutube'
import IconPen from '../../elements/svg_icons/IconPen'
import {FC, useState} from 'react'
import ReviewModal from '../../modalwindows/ReviewModal'
import {Flex, Image, Skeleton, Typography} from "antd";
import CardImageUtils from "../../utils/CardImageUtils";
import {CheckCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {NavigationPages} from "../../../common/navigation/navigation-pages";
import {CommunityDto, ID, WordList} from "../../../shared/types/api";


interface RepeatSuggestionProps {
    isLoading: boolean
    repeatSuggestion: Array<WordList>,
    openSuggestionList: (wl: WordList) => void,
    clearAndClose: () => void
}

const {Text} = Typography;

const RepeatSuggestion: FC<RepeatSuggestionProps> = ({
                                                         isLoading,
                                                         repeatSuggestion,
                                                         openSuggestionList,
                                                         clearAndClose
                                                     }) => {

    return (
        <div style={{marginTop: 16}}>
            {isLoading ? (
                <Skeleton active paragraph={{rows: 2}} title={false}/>
            ) : repeatSuggestion.length > 0 ? (
                <>
                    <div style={{marginBottom: 8}}>
                        <Text>Рекомендуем повторить:</Text>
                    </div>
                    <Flex gap={8} wrap="wrap">
                        {repeatSuggestion.slice(0, 3).map((rs) => (
                            <Flex
                                key={rs.id}
                                vertical
                                align="center"
                                gap={6}
                                style={{
                                    width: 110,
                                    padding: 8,
                                    border: '1px solid var(--color-bg-muted)',
                                    borderRadius: 8
                                }}
                            >
                                <Image
                                    src={CardImageUtils.getCardImage(rs.tree)}
                                    preview={false}
                                    width={80}
                                    height={80}
                                    style={{borderRadius: 6}}
                                />

                                <Text
                                    style={{
                                        fontSize: 12,
                                        textAlign: 'center'
                                    }}
                                    ellipsis
                                >
                                    {rs.listName}
                                </Text>

                                <GEButton
                                    size="small"
                                    type="primary"
                                    onClick={() => openSuggestionList(rs)}
                                >
                                    Повторить
                                </GEButton>
                            </Flex>
                        ))}
                    </Flex>
                </>
            ) : (
                <Flex vertical gap={8} align="flex-start">
                    <Text type="secondary">
                        Сегодня нечего повторять. Все списки слов изучены! <CheckCircleOutlined
                        style={{color: 'var(--color-success)'}}/>
                    </Text>
                    <GEButton
                        type="link"
                        size="small"
                        icon={<PlusOutlined/>}
                        style={{padding: 0}}
                        onClick={() => {
                            clearAndClose()
                            window.location.href = NavigationPages.DICTIONARY
                        }
                        }
                    >
                        Добавить новый список в словаре
                    </GEButton>
                </Flex>
            )}
        </div>
    )
}

export default RepeatSuggestion
